
import React from "react";
import { MarketItem } from "./MarketItem";
import { Market, availableMarkets } from "./marketData";

interface MarketListProps {
  selectedMarkets: string[];
  defaultMarket: string;
  activeMarkets: string[];
  onCheckboxChange: (country: string, checked: boolean) => void;
  onDefaultChange: (country: string, checked: boolean) => void;
  onActiveChange: (country: string, checked: boolean) => void;
}

export const MarketList: React.FC<MarketListProps> = ({
  selectedMarkets,
  defaultMarket,
  activeMarkets,
  onCheckboxChange,
  onDefaultChange,
  onActiveChange
}) => {
  return (
    <div className="max-h-[400px] overflow-y-auto pr-2">
      <div className="grid grid-cols-4 gap-2 mb-2 text-xs font-medium text-gray-500 px-1">
        <div>Sélectionner</div>
        <div>Marché</div>
        <div>Défaut</div>
        <div>Actif</div>
      </div>
      
      {availableMarkets.map((market) => (
        <MarketItem 
          key={market.code}
          market={market}
          isSelected={selectedMarkets.includes(market.country)}
          isDefault={defaultMarket === market.country}
          isActive={activeMarkets.includes(market.country)}
          onCheckboxChange={onCheckboxChange}
          onDefaultChange={onDefaultChange}
          onActiveChange={onActiveChange}
        />
      ))}
    </div>
  );
};
